import { render, staticRenderFns } from "./Illustration.vue?vue&type=template&id=4c838cbc"
import script from "./Illustration.vue?vue&type=script&lang=js"
export * from "./Illustration.vue?vue&type=script&lang=js"
import style0 from "./Illustration.vue?vue&type=style&index=0&id=4c838cbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/vercel/path0/components/elements/Section.vue').default})
